<template>
  <div class="flex flex-row w-full">
    <div class="sterlingbars-wrapper sterlingbars-feedback sterlingbars-circles w-full bg-gray-300">
      <div class="trait-wrapper w-full relative h-8">
        <div class="circle-name">{{ name }}</div>
        <div class="w-full border-b-2 border-white mt-4 absolute"></div>
        <div class="trait-bar bg-transparent">
          <div class="trait-score" :style="{ left: percentagescore }">
            <i aria-hidden="true" class="material-icons pr-0">{{circles_icon}}</i>
          </div>
          <div v-if="std" class="trait-spread" :style="{ width: spreadwidth, left: spreadleft }"> &nbsp;
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<!-- For Yellow Bars - IF( (userScore<(avg-std) OR userScore>(avg+std) ) -->
<script>
export default {

  props: {
    name: '',
    avg: '',
    std: '',
    score: '',
    circles_icon: {
      default: 'circle',
    }
  },
  data() {
    return {
      avgFloat: parseFloat(this.avg),
      stdFloat: parseFloat(this.std)
    }
  },
  computed: {
    percentagescore : function() {
      return (this.score) + '%';
    },
    spreadwidth : function() {
      return (this.std) * 2 + '%';
    },
    spreadleft : function() {
      return (this.avg) - (this.std) + '%';
    },
    outlierleft : function() {
      return (this.avg - this.std);
    },
    outlierright : function() {
      return (this.avgFloat + this.stdFloat);
    },
    outlier : function() {
      return (this.score) < (this.avgFloat - this.stdFloat) || (this.score) > (this.avgFloat + this.stdFloat);
    }
  },

};
</script>
